import React, {useState} from "react";
import styles from "../assets/css/similarPosts.module.scss";
import {Card, Container, Grid, Hidden, Typography} from "@mui/material";
import {Link} from "react-router-dom";
import configs from "../utils/config.json";

const SimilarPosts = (props) => {

    return <div className={styles.container}>
        <Container maxWidth={"xl"}>
            <Grid container className={styles.wrapper}>
                {props.content.map((item, index) => <Grid item xs={12} md={4} key={index}>
                    <Item {...item} key={index}/>
                </Grid>)}
            </Grid>


        </Container>
    </div>;
};

export default SimilarPosts;


const Item = (props) => {
    return<>

        <Hidden mdUp>
            <Link to={`/blog/${props.id}`} style={{display:"flex",marginTop:15}}  className={styles.link2}>
                <Card elevation={11} style={{display:"flex",width:"100%",background:"rgb(34, 40, 47)"}}>
                    <img src={`${configs.server.Storage}/${props.img}`} alt={""} style={{width:"35%",height:200}}/>
                    <div style={{width:"65%",padding:15}}>
                        <Typography variant={"h6"} component={"h4"} style={{color:"#fff"}}>
                            {props.title}
                        </Typography>
                        <Typography variant={"subtitle2"} component={"p"} style={{textAlign: "justify",color:"#fff",maxHeight:170,textOverflow:"ellipsis",whiteSpace:"nowrap",overflow:"hidden"}}>
                            {props.description}
                        </Typography>
                    </div>
                </Card>
            </Link>
        </Hidden>
        <Hidden mdDown>

            <Link to={`/blog/${props.id}`} className={styles.link2}>
                <Card elevation={11} className={styles.item}>

                    <img src={`${configs.server.Storage}/${props.img}`} alt={""}/>
                    <Typography variant={"h6"} component={"h4"}>
                        {props.title}
                    </Typography>

                    <Typography variant={"subtitle2"} component={"p"} style={{textAlign: "justify"}}>
                        {props.description}
                    </Typography>

                </Card>
            </Link>

        </Hidden>
    </>




};
